import React, { useState, useEffect } from 'react';
import CardCountMetric from '../CardCountMetric';
import api from '../../services/api';
import { notifyApiError } from '../../services/apiError';
import downloadFile from '../../utils/downloadFile';
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import { store } from "react-notifications-component";
import IconXlsx from '../../assets/icons/icon-baixar-xlsx.png';

const QtdReceitasEmitidas = ({ dtInicial, dtFinal, ...props }) => {

    const [qtdReceita, setQtdReceita] = useState(null);
    const [trendPercent, setTrendPercent] = useState(null);
    const [loadingXls, setShowLoadingXls] = useState(false);

    const searchInitialData = async () => {
        setQtdReceita(null);

        try {
            const response = await api.get('/relatorios/receitas-emitidas', {
                params: { dtInicial, dtFinal },
            });

            setQtdReceita(response.data.data.total);
            setTrendPercent(response.data.data.percentage ?? null);
        } catch (error) {
            notifyApiError(error, 'Falha ao carregar total de receitas emitidas.');
        }
    }

    const gerarXLS = async () => {
        if (loadingXls) return;

        const payload = { dtInicial, dtFinal, reportTitle: 'Total de receitas emitidas' };

        try {
            setShowLoadingXls(true);
            window.onbeforeunload = () => "Seu relatório está sendo gerado. Tem certeza que deseja sair?";

            const response = await api.post("/relatorios/geral", payload);

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, "relatorio-receitas.xlsx");
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true,
                },
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
        } finally {
            setShowLoadingXls(false);
            window.onbeforeunload = null;
        }
    };

    useEffect(() => {
        searchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dtInicial, dtFinal])

    return (
        <CardCountMetric
            title="Total de receitas emitidas"
            value={qtdReceita}
            loading={qtdReceita === null || loadingXls}
            trendPercent={trendPercent}
            trendLabel="vs. período anterior"
            isNew={trendPercent === null && qtdReceita > 0}
            stackTrend
            actions={
                <a
                    onClick={() => gerarXLS()}
                    aria-disabled={loadingXls}
                    style={{ cursor: loadingXls ? 'not-allowed' : 'pointer', opacity: loadingXls ? 0.4 : 1 }}
                >
                    <img width={18} src={IconXlsx} alt="Baixar XLSX" />
                </a>
            }
        />
    )
}

export default QtdReceitasEmitidas;
